import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import EditIcon from '@mui/icons-material/Edit';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Button, Chip, Collapse, IconButton, Paper, Stack, Typography } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectFramework,
  selectFrameworkData,
  selectTotalControlCount,
  selectTotalImplementationStatus,
} from '../../redux/reducers/frameworkReducer';

function FrameworkItem({ frameworkId }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const framework = useSelector((state) => selectFrameworkData(state, frameworkId));
  const controlCount = useSelector((state) => selectTotalControlCount(state, frameworkId));
  const implementationCount = useSelector((state) => selectTotalImplementationStatus(state, frameworkId));
  const [showStatus, setShowStatus] = useState(false);

  const handleEditDetails = () => {

  };

  const handleViewFramework = () => {
    dispatch(selectFramework(frameworkId));
  };

  const toggleShowStatus = () => {
    setShowStatus(!showStatus);
  };

  const getChipLabel = () => {
    let label;
    if (controlCount === 0) {
      label = '-';
    } else {
      label = `${Math.round((implementationCount.fullyImplemented / controlCount) * 1000) / 10}% Implemented`;
    }
    return label;
  };

  return (
    <Paper elevation={4} variant="elevation" subtype="frameworkField">
      <Stack spacing={2}>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Stack direction="row" alignItems="center" spacing={2}>
            <Typography id={framework.title} variant="overline">{framework.title}</Typography>
            <Chip
              size="medium"
              color="controlChip"
              label={getChipLabel()}
            />
          </Stack>
          <Stack direction="row" spacing={1}>
            <Button
              id='edit-details'
              variant="outlined"
              endIcon={<EditIcon />}
              onClick={handleEditDetails}
              sx={{ minWidth: 'max-content' }}
            >
              {t('framework.buttonEdit')}
            </Button>
            <Button
              id='view-and-edit'
              variant="contained"
              endIcon={<ChevronRightIcon />}
              onClick={handleViewFramework}
              sx={{ minWidth: 'max-content' }}
            >
              {t('framework.buttonView')}
            </Button>
          </Stack>
        </Stack>
        <Typography>{framework.description}</Typography>
        <Stack spacing={1}>
          <Stack direction="row" alignItems="center" spacing={1}>
            <Typography>{t('framework.controls.status')}</Typography>
            <IconButton id='implementation-status' onClick={toggleShowStatus}>
              {showStatus ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </IconButton>
          </Stack>
          <Collapse in={showStatus} unmountOnExit>
            <Stack justifyContent="space-evenly" direction="row" spacing={2}>
              <Paper variant="elevation" subtype="completion" align="center" sx={{ width: '100%' }}>
                <Stack direction="column">
                  <Typography variant="overline">{t('framework.controls.statusCount.notImplemented')}</Typography>
                  <Typography id='not-implemented-count' variant="overline">{implementationCount.notImplemented}</Typography>
                  <Typography id='not-implemented-percent' variant="overline">
                    {`${Math.round((implementationCount.notImplemented / controlCount) * 1000) / 10}%`}
                  </Typography>
                </Stack>
              </Paper>
              <Paper variant="elevation" subtype="completion" align="center" sx={{ width: '100%' }}>
                <Stack direction="column">
                  <Typography variant="overline">{t('framework.controls.statusCount.partiallyImplemented')}</Typography>
                  <Typography id='partially-implemented-count' variant="overline">{implementationCount.partiallyImplemented}</Typography>
                  <Typography id='partially-implemented-percent' variant="overline">
                    {`${Math.round((implementationCount.partiallyImplemented / controlCount) * 1000) / 10}%`}
                  </Typography>
                </Stack>
              </Paper>
              <Paper variant="elevation" subtype="completion" align="center" sx={{ width: '100%' }}>
                <Stack direction="column">
                  <Typography variant="overline">{t('framework.controls.statusCount.fullyImplemented')}</Typography>
                  <Typography id='fully-implemented-count' variant="overline">{implementationCount.fullyImplemented}</Typography>
                  <Typography id='fully-implemented-percent' variant="overline">
                    {`${Math.round((implementationCount.fullyImplemented / controlCount) * 1000) / 10}%`}
                  </Typography>
                </Stack>
              </Paper>
            </Stack>
          </Collapse>
        </Stack>
      </Stack>
    </Paper>
  );
}

export default FrameworkItem;
